import GridItem from "./GridItem";

export default function GridItemTS({ ...props }) {
  return (
    <GridItem {...props}>
      {props.children}
    </GridItem>
  );
}
